import { ActivityEntityName, TaskTarget } from '@jms/model/entities';
import { ContactMergeData, ContactMergeSchema } from './contact.merge.data';
import { getSchema, MergeField, MergeSchema } from '../../decorators';

@MergeSchema({
    entity: ActivityEntityName.Task,
    name: 'TaskMergeDataSchema',
})
export class TaskMergeData {
    @MergeField()
    name: string;

    @MergeField()
    description: string;

    @MergeField({
        nestedFieldSchema: ContactMergeSchema
    }
    )
    assignee: ContactMergeData;

    @MergeField()
    dueDate: Date;

    @MergeField({
        displayName: 'Assign To Role'
    })
    target: TaskTarget;

    @MergeField()
    phase: string;

    @MergeField()
    tags: string;

    // @MergeField({
    //     displayName: 'Shared With'
    // })
    // shared: string;

    @MergeField({
        displayName: 'Completed Status',
    })
    status: string;

    @MergeField({
        nestedFieldSchema: ContactMergeSchema
    })
    completedBy: ContactMergeData;

    @MergeField()
    completedOn: Date;
}

export const TaskMergeDataSchema = getSchema(TaskMergeData);

@MergeSchema({
    entity: ActivityEntityName.Task,
})
export class TaskArrayMergeData {

    @MergeField({
        arraySchemaName: 'TaskMergeDataSchema',
    })
    tasks: TaskMergeData[] = [];
}

export const TaskArrayMergeDataSchema = getSchema(TaskArrayMergeData);